import { gisBases } from "@/mocks/documentos";

export default function GisQualityPanel() {
  const total = gisBases.length;
  const withSrid = gisBases.filter((b) => b.srid.length > 0).length;
  const withValidGeom = gisBases.filter((b) => b.hasValidGeometry).length;
  const withMetadata = gisBases.filter((b) => b.hasMetadata).length;
  const withProject = gisBases.filter((b) => b.projectId.length > 0).length;
  const pending = gisBases.filter((b) => b.status === "Pendente validação").length;

  const metrics = [
    { label: "Bases com SRID definido", value: Math.round((withSrid / total) * 100), target: 100, status: withSrid === total ? "bom" as const : "regular" as const },
    { label: "Bases com geometria válida", value: Math.round((withValidGeom / total) * 100), target: 95, status: withValidGeom >= total - 1 ? "bom" as const : "regular" as const },
    { label: "Bases com metadados completos", value: Math.round((withMetadata / total) * 100), target: 90, status: withMetadata >= total - 1 ? "bom" as const : "ruim" as const },
    { label: "Bases vinculadas a projeto", value: Math.round((withProject / total) * 100), target: 75, status: withProject >= total / 2 ? "bom" as const : "regular" as const },
    { label: "Bases pendentes de validação", value: pending, target: 0, status: pending === 0 ? "bom" as const : "ruim" as const },
  ];

  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-4 md:p-5">
      <h3 className="text-sm font-semibold text-foreground-900 mb-4">Qualidade GIS</h3>
      <div className="space-y-3">
        {metrics.map((m) => (
          <div key={m.label}>
            <div className="flex justify-between text-xs mb-1">
              <span className="text-foreground-600">{m.label}</span>
              <span className={`font-semibold ${m.status === "bom" ? "text-primary-600" : m.status === "regular" ? "text-caution-600" : "text-danger-600"}`}>
                {m.status === "ruim" ? `${m.value} bases` : `${m.value}%`}
              </span>
            </div>
            <div className="w-full bg-background-200 rounded-full h-2">
              <div
                className={`h-2 rounded-full transition-all ${m.status === "bom" ? "bg-primary-500" : m.status === "regular" ? "bg-caution-500" : "bg-danger-500"}`}
                style={{ width: m.status === "ruim" ? `${Math.max((1 - m.value / total) * 100, 5)}%` : `${Math.min(m.value, 100)}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}